import React,{useState,useMemo,useCallback} from 'react'
import { Table,Space,Checkbox, Flex, Radio,} from 'antd'
import { useBusinessNumListQuery, } from '../../store/ReactWebSiteApi';
import Main from '../../cpn/Main';
import LedgerAdd from './LedgerAdd';
import LedgerEdit from './LedgerEdit';
import LedgerDel from './LedgerDel';
import LedgerQuery from './LedgerQuery';
import LedgerCheck from './LedgerCheck';
import {FileTextOutlined} from '@ant-design/icons';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
import LedgerAudit from './LedgerAudit';
import dayjs from 'dayjs';
import LedgerAuditTag from './LedgerAuditTag';
import LedgerQueryModal from './LedgerQueryModal';
function LedgerList() {
    // 安全的localStorage解析函数
    const safeParse = (key, defaultValue = '') => {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) : defaultValue;
        } catch (error) {
            console.warn(`Failed to parse localStorage key ${key}:`, error);
            return defaultValue;
        }
    };

    // 使用 useMemo 优化初始 query 对象，避免每次渲染都创建新对象
    const initialQuery = useMemo(() => ({
        ebn_e_id:safeParse('e_id'),
        eu_id:safeParse('eu_id'),
        ebn_ctime:safeParse('ebn_query_dateNew'),
        action:'search',
        ebn_eci_id:'',
        ebn_dept_id:safeParse('ebn_query_dept'),  
        ebn_client_id:safeParse('ebn_query_client'),
        ebn_uid:safeParse('ebn_query_uid'),
        ebn_date_s:safeParse('ebn_query_date_s'),
        ebn_date_e:safeParse('ebn_query_date_e'),
        ebn_content:safeParse('ebn_query_ec_content'),   
        ebn_team_num:safeParse('ebn_query_team_num'),
        ebn_yw_id:safeParse('ebn_query_yw_id'),
        ebn_state:'2'
    }), []); // 空依赖数组，只在组件初始化时执行一次

    const [query,setQuery] = useState(initialQuery); 
    const {data,isSuccess,isLoading,error} = useBusinessNumListQuery(query,{refetchOnMountOrArgChange:1,})
    const [status,setStatus] = useState('all')
    
    // 使用 useMemo 优化数据处理逻辑，避免每次渲染都重新计算
    const processedList = useMemo(() => {
        if (!isSuccess || !data || data.Status !== 'success') {
            return [];
        }
        
        // 数据映射
        const newArr = data.Result.map(item => {
            const {ebn_id:key,guige,ebn_client_id,ebn_yw_name,ebn_team_num,ebn_dept_id,photo_album_id,ebn_expenditure_num,ebn_income_num,ed_name,ebn_name,ebn_content,ebn_uname,ebn_ctime,ebn_update_ctime,ebn_update_uname,ec_name,ebn_image_file,ebn_date,eg_name,ebn_eg_id,ebn_audit2_ctime,ebn_audit4_uname,ebn_audit4_ctime,ebn_audit3_uname,ebn_audit3_ctime,ebn_audit2_uname,ebn_audit_ctime,ebn_audit_uname,ebn_state,} = item;
            return {key,guige,ebn_client_id,ebn_yw_name,ebn_team_num,ebn_dept_id,photo_album_id,ebn_expenditure_num,ebn_income_num,ed_name,ebn_name,ebn_content,ebn_uname,ebn_ctime,ebn_update_ctime,ebn_update_uname,ec_name,ebn_image_file,ebn_date,eg_name,ebn_eg_id,ebn_audit4_ctime,ebn_audit4_uname,ebn_audit3_ctime,ebn_audit3_uname,ebn_audit2_ctime,ebn_audit2_uname,ebn_audit_ctime,ebn_audit_uname,ebn_state,}
        });
        
        // 根据状态过滤数据
        let filteredArr = newArr;
        if (status === 'notStart' && query.action === 'search') {
            filteredArr = newArr.filter((item) => dayjs().isBefore(dayjs(item.ebn_date)));
        } else if (status === 'started' && query.action === 'search') {
            filteredArr = newArr.filter((item) => dayjs().isAfter(dayjs(item.ebn_date)));
        } else if (status === 'auditOne' && query.action === 'search') {
            filteredArr = newArr.filter((item) => item.ebn_audit_ctime);
        } else if (status === 'auditTwo' && query.action === 'search') {
            filteredArr = newArr.filter((item) => item.ebn_audit2_ctime);
        }
        
        // 排序
        return filteredArr.sort((a, b) => {
            const aTimeString = a.ebn_team_num;
            const bTimeString = b.ebn_team_num;
            return bTimeString - aTimeString;
        });
    }, [data, isSuccess, status, query.action]);  

    const columns = [
        {
            key: '1',
            title: '团队编号',
            dataIndex: 'ebn_team_num', 
            sorter: {
                compare: (a, b) => a.ebn_team_num - b.ebn_team_num,
            },
            width:'7%',           
            render:(text,record) => {
                return  <LedgerCheck 
                            titleType='数字'
                            ebn_id={record.key} 
                            ebn_dept_id={record.ebn_dept_id}
                            ebn_team_num={record.ebn_team_num}
                        />
            }
        }, 
        {
            key: '2',
            title: '出发日期',
            dataIndex: 'ebn_date',
            width:'6%'  
        }, 
        {
            key: '3',
            title: '部门',
            dataIndex: 'ed_name', 
            width:'6%'            
        },  
        {
            key: '4',
            title: '销售员',
            dataIndex: 'ebn_yw_name',
            width:'6%'  
        },  
        {
            key: '5',
            title: '客户',
            dataIndex: 'ec_name',
            width:'6%'  
        },         
        {
            key: '6',
            title: '产品',
            dataIndex: 'eg_name',
            width:'10%',
            hidden:'true',  
            render:(text,record) => {
                let arr = []
                if(record.guige){
                    arr = record.guige.map((item) => {
                        return <span key={item.egg_id}>{item.egg_name}{item.guigeNum}</span>
                    })
                }
                return <>
                    <div>{text}</div>
                    <Space>{arr}</Space>
                </>
            }
        },     
        {
            key: '7',
            title: '备注',
            dataIndex:"ebn_content",
            render:(text) => {
                return <div style={{maxWidth:"260px",}}>{text}</div>
            }
            
        }, 
        {
            key: '8',
            title: '收入',
            dataIndex: 'ebn_income_num',
            width:'4%'  
        }, 
        {
            key: '9',
            title: '支出',
            dataIndex: 'ebn_expenditure_num',
            width:'4%'  
        }, 
        {
            key: '10',
            title: '利润',
            render:(_,record) => {
                return <>{(+record.ebn_income_num + +record.ebn_expenditure_num).toFixed('2')}</>
            },
            width:'4%'  
        },     
        {
            key: '11',
            title: '操作员',
            render:(_,record) => {
                return<>{record.ebn_ctime + ' ' + record.ebn_uname.replace(/"/g,'')}</>
            },
            width:'8%'  
        },            
        // {
        //     key: 'id',
        //     title: '编号',
        //     dataIndex: 'key',           
        // }, 
              
        {
            key: '12',
            title: '审核',
            render:(_,record) => {
                return <>
                {/* {record.ebn_audit_ctime && <div><Tag color='volcano'>{record.ebn_audit_uname}审核</Tag></div>} */}
                {/* {record.ebn_audit2_ctime && <div style={{marginTop:"10px"}}><Tag color='green'>{record.ebn_audit2_uname}复核</Tag></div>} */}
                    <LedgerAuditTag 
                        ebn_audit_uname={record.ebn_audit_uname} 
                        ebn_audit2_uname={record.ebn_audit2_uname} 
                        ebn_audit3_uname={record.ebn_audit3_uname} 
                        ebn_audit4_uname={record.ebn_audit4_uname} 
                        ebn_audit_ctime={record.ebn_audit_ctime} 
                        ebn_audit2_ctime={record.ebn_audit2_ctime} 
                        ebn_audit3_ctime={record.ebn_audit3_ctime} 
                        ebn_audit4_ctime={record.ebn_audit4_ctime} 
                        ebn_id={record.key}
                        ebn_state={record.ebn_state}
                        direction='vertical'
                    />
                </>
            },
            width:'6%'  
        },             
        {
            key: '13',
            width:'11%',  
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <LedgerCheck 
                            text={<Space><FileTextOutlined/>BZD{record.ebn_team_num}</Space>} 
                            ebn_id={record.key} 
                            ebn_dept_id={record.ebn_dept_id}
                            ebn_team_num={record.ebn_team_num}
                        />
                        
                        {/* <a onClick={() => {navi(`/LedgerCheck?esv_id=${param.get('esv_id')}&id=${record.key}&ebn_team_num=${record.ebn_team_num}&ebn_dept_id=${record.ebn_dept_id}&ledgerName=${param.get('ledgerName')}&ebn_client_id=${record.ebn_client_id}&ec_name=${record.ec_name}`)}}>查看</a> */}
                        <LedgerEdit 
                            ebn_audit_ctime={record.ebn_audit_ctime} 
                            ebn_id={record.key}  
                            ebn_dept_id={record.ebn_dept_id} 
                            ebn_state={record.ebn_state}
                        />
                        <LedgerDel 
                            ebn_id={record.key}
                            ebn_audit_ctime={record.ebn_audit_ctime} 
                            ebn_team_num={record.ebn_team_num}
                            ebn_state={record.ebn_state}
                        />
                        <LedgerAudit
                            ebn_audit4_ctime={record.ebn_audit4_ctime}
                            ebn_audit3_ctime={record.ebn_audit3_ctime}
                            ebn_audit2_ctime={record.ebn_audit2_ctime}
                            ebn_audit_ctime={record.ebn_audit_ctime} 
                            ebn_id={record.key}
                            ebn_state={record.ebn_state}
                        />

                    </Space>
                </>
            }
        },
    ]
    //当前页码
    const [current, setCurrent] = useState(safeParse('ebn_query_page', '1'));
    //当前每页数量
    const [pageSize,setPageSize] = useState(safeParse('ebn_query_page_size', "20"))
    //列显示   
    const defaultCheckedList = columns.map((item) => item.key);
    const [checkedList, setCheckedList] = useState(() => {
        const stored = safeParse('groupListColumn');
        return stored ? stored.split(',') : defaultCheckedList;
    });
    const options = columns.map(({ key, title }) => ({
        label: title,
        value: key,
    }));
    const newColumns = columns.map((item) =>{
        const stored = safeParse('groupListColumn');
        if(stored){
            return {...item,hidden:!stored.includes(item.key)}
        }else{
            return {...item,hidden: !checkedList.includes(item.key),}
        }
    });
     
    // 使用 useCallback 优化 getQuery 函数，避免子组件不必要的重新渲染
    const getQuery = useCallback((values) => {
        setQuery(prevState => ({
            ...prevState,            
            action:'search',
            ebn_dept_id:values.ebn_dept_id || '',
            ebn_client_id:values.ebn_client_id || '',
            ebn_uid:values.ebn_uid || '',
            ebn_team_num:values.ebn_team_num || '',
            ebn_date_s:values.ebn_date_s || '',
            ebn_date_e:values.ebn_date_e || '', // 修复了原来的 bug: values.ebn_date_s
            ebn_ctime:values.ebn_ctime || '',
            ebn_content:values.ebn_content || '',
            ebn_yw_id:values.ebn_yw_id || '',
        }));
    }, []);
    
    // 优化分页处理函数
    const handlePaginationChange = useCallback((e, f) => {
        setCurrent(e)
        setPageSize(f)
        localStorage.setItem('ebn_query_page', JSON.stringify(e));
        localStorage.setItem('ebn_query_page_size', JSON.stringify(f));
    }, []);
    
    // 优化搜索样式处理函数
    const handleSearchStyleChange = useCallback((e) => {
        setSearchStyle(e.target.value)
        localStorage.setItem('LedgerListSearch', JSON.stringify(e.target.value))
    }, []);
    
    // 优化列显示处理函数
    const handleColumnChange = useCallback((value) => {
        localStorage.setItem('groupListColumn', JSON.stringify(value + ''))
        setCheckedList(value);
    }, []);
    
    //搜索样式
    const [searchStyle,setSearchStyle] = useState('1')
    
    // 错误处理
    if (error) {
        return (
            <Main t1='团队'>
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <h3>数据加载失败</h3>
                    <p>请检查网络连接或联系管理员</p>
                    <button onClick={() => window.location.reload()}>重新加载</button>
                </div>
            </Main>
        );
    }
    
    return (
        <Main  t1='团队' >
            {query.ebn_state==='2' ? 
                <Flex align='center' wrap>
                    <LedgerAdd />
                    {safeParse('LedgerListSearch', '1')==='1' ? <LedgerQuery  
                        getQuery={getQuery} 
                        getStatus={setStatus}
                    />:<LedgerQueryModal  
                            getQuery={getQuery} 
                            getStatus={setStatus}
                        />}
                    <a 
                        style={{
                            fontSize:"18px"
                        }}
                        onClick={() => {
                            setQuery(prevState=>({...prevState,ebn_state:'1',action:'search'}))
                        }}
                    ><DeleteOutlined /> 已删除</a>
                </Flex>:<Flex>
                            <a 
                                style={{
                                    fontSize:"18px"
                                    }}
                                onClick={() => {
                                    setQuery(prevState=>({...prevState,ebn_state:'2',action:'search'}))
                                }}
                            ><LogoutOutlined /> 未删除团队</a>
                        </Flex>}
            <Table 
                style={{marginTop:"20px"}}
                columns={newColumns} 
                dataSource={processedList} 
                loading={isLoading}
                pagination={{
                    showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,
                    current:current,
                    onChange: handlePaginationChange,
                    pageSize:pageSize,
                    showTitle:true
                }}/>
            <div style={{textAlign:'right',width:"100%"}}>
                <Space>
                    <div>
                        <span>查询样式：</span>
                        <Radio.Group
                            value={searchStyle} 
                            onChange={handleSearchStyleChange}>
                            <Radio value='1'>平铺式</Radio>
                            <Radio value='2'>弹出式</Radio>
                        </Radio.Group>
                    </div>
                    <div>
                        <span>列显示：</span>
                        <Checkbox.Group 
                            value={checkedList}
                            options={options}
                            onChange={handleColumnChange}>产品 
                        </Checkbox.Group>  
                    </div>   
                </Space>           
            </div>
        </Main>
    )
}

export default LedgerList